import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-3" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "col-md-auto ml-md-auto" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-auto contCnt" }
const _hoisted_8 = { class: "col-md-auto contCnt" }
const _hoisted_9 = { class: "demo" }
const _hoisted_10 = { class: "table table-sm m-0 tableClaim" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_claimlist_row = _resolveComponent("Mo_claimlist_row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary waves-effect waves-themed mr-1",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addRow())),
          disabled: _ctx.btnDisable
        }, " 行追加 ", 8, _hoisted_3),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary waves-effect waves-themed mr-1",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.delRow())),
          disabled: _ctx.btnDisable
        }, " 行削除 ", 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { style: {"color":"red","padding-right":"20px"} }, "※単価は、文字入力となるため、カンマや小数点が必要な場合は手入力して下さい。", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-auto contTitle" }, "小計", -1)),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm mr-1 text-right",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sum) = $event)),
              disabled: ""
            }, null, 512), [
              [_vModelText, _ctx.sum]
            ])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-md-auto contTitle" }, "請求金額", -1)),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm mr-1 text-right",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sumTax) = $event)),
              disabled: ""
            }, null, 512), [
              [_vModelText, _ctx.sumTax]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("table", _hoisted_10, [
        _cache[9] || (_cache[9] = _createElementVNode("thead", { class: "bg-fusion-50" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "fixhead headClaim cwC_1" }, "品名"),
            _createElementVNode("th", { class: "fixhead headClaim cwC_2" }, "数量"),
            _createElementVNode("th", { class: "fixhead headClaim cwC_25" }, "単位"),
            _createElementVNode("th", { class: "fixhead headClaim cwC_3" }, "単価"),
            _createElementVNode("th", { class: "fixhead headClaim cwC_4" }, "金額"),
            _createElementVNode("th", { class: "fixhead headClaim cwC_5" }, "消費税"),
            _createElementVNode("th", { class: "fixhead headClaim cwC_6" }, "税込金額"),
            _createElementVNode("th", { class: "fixhead headClaim cwC_7" }, "計算方法"),
            _createElementVNode("th", { class: "fixhead headClaim cwC_8" }, "備考")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createBlock(_component_Mo_claimlist_row, {
              key: item.c_claim_rownum!,
              item: item,
              btnDisable: _ctx.btnDisable,
              "onUpdate:btnDisable": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.btnDisable) = $event)),
              onReCalc: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sumCalc()))
            }, null, 8, ["item", "btnDisable"]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}